import React from "react"
import PropTypes from "prop-types"
import "./navbar.css"
import Routes from "../Routes"
// import AnchorLink from "react-anchor-link-smooth-scroll"
import Link from "gatsby-link"
// import Subscribe from "../../components/Subscribe"
// import $ from "jquery"
// import { DropdownButton, MenuItem, ButtonToolbar } from "react-bootstrap"
// const Logo = "http://alpexonline.com/assets/images/LOGO.png"

export class NavBar extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			activeNav: "",
			prevScrollpos: window.pageYOffset,
			routeUrl: "/",
			isNavChange: true
		}
	}
	handleScroll = (event) => {
		// // console.log("Scroolsadsadsd", event)
		const { prevScrollpos } = this.state
		let currentScrollPos = window.scrollY
		// let itemTranslate = Math.min(0, currentScrollPos / 3)
		const visible = currentScrollPos === 0 && (currentScrollPos - 1 < (prevScrollpos))
		this.setState({
			prevScrollpos: currentScrollPos,
			visible
		})
	}
	componentWillUnmount () {
		window.removeEventListener("scroll", this.handleScroll, true)
	}
	componentDidMount = () => {
		window.addEventListener("scroll", this.handleScroll, true)
		this.setState({
			// isNavChange: false,
			routeUrl: window.location.pathname,
		})
		// setTimeout(() => {
		// 	this.setState({
		// 	})
		// }, 1000)
		// console.log(window.location)
	}
	handleActiveNav = (identifier) => {
		const { getActiveRoute } = this.props
		// this.setState({
		// })
		this.setState({
			// isNavChange: false,
			routeUrl: "/",
		})
		// setTimeout(() => {
		// 	this.setState({
		// 		isNavChange: true,
		// 	})
		// }, 0)
	}
	render () {
		const { activeNav, routeUrl, isNavChange } = this.state
		// console.log("this.props", this.props, routeUrl)
		let activeUrl = routeUrl === "/" || routeUrl === "/home"
		return (<div id="navBar" className="nav__bar">
			<div className="logo"><div className=""><a href="/" className=""><img src="https://winpeforum.com/assets/elements/winpe_new_logo2.png" alt="Winpe" /></a></div></div>
			<div className="right__to__logo">
				{isNavChange ? Routes.map((route) => {
					return <span key={route.id} className="dropdown blog">
						{route.isDifferentPage ? <div>
							<a className={`${(routeUrl === "/knowledgeresources" || routeUrl === "/connect" || routeUrl === "/insights") ? "" : ""}`} href={`/${route.identifier}`}>{route.title}</a>
						</div>
							: !activeUrl
								? <Link onClick={() => this.handleActiveNav(route.title)} to={`/home#${route.identifier}`} className={`${""} ${route.identifier === activeNav.toLowerCase() ? "active" : ""}`}>{route.title}</Link>
								: <a onClick={() => this.handleActiveNav(route.title)} href={`/home#${route.identifier}`} className={`anchor__text ${route.identifier === activeNav.toLowerCase() ? "active" : ""}`}>{route.title}</a>}
						<div className="dropdown-content">
							{route.dropdown && route.dropdown.map((item) => {
								return item.isDifferentPage ? <div key={item}>
									<a className="" href={`/${item.identifier}`} key={item.id}><span>{item.title}</span></a>
								</div> : !activeUrl
									? <Link to={`/home#${item.identifier}`} key={item.id} className="">
										<span>{item.title}</span>
									</Link>
									: <a href={`#${item.identifier}`} key={item.id} className="">
										<span>{item.title}</span>
									</a>
							})}
						</div>
					</span>
				}) : null}
			</div>
			<div className="desTop_sm">
				<div className="social_icons_top">
					<div className="iconn">
						<a rel="noopener noreferrer" href="https://www.facebook.com/winpeforum/" target="_blank" className=""><i className="fa fa-facebook"></i></a>
					</div>
					<div className="iconn">
						<a rel="noopener noreferrer" href="https://twitter.com/winpeforum" target="_blank" className=""><i className="fa fa-twitter"></i></a>
					</div>
					<div className="iconn">
						<a rel="noopener noreferrer" href="https://www.linkedin.com/company/winpeforum" target="_blank" className=""><i className="fa fa-linkedin"></i></a>
					</div>
					<div className="iconn">
						<a rel="noopener noreferrer" href="https://www.instagram.com/WinPEforum/" target="_blank" className=""><i className="fa fa-instagram"></i></a>
					</div>
					<div className="iconn">
						<a rel="noopener noreferrer" href="https://www.youtube.com/watch?v=q-bE10X9KcA&t=2s" target="_blank" className=""><i className="fa fa-youtube"></i></a>
					</div>
				</div>
			</div>
			{ /*
			<div className="desTop">
				<div className="subRight">
					<Subscribe />
				</div>
			</div>
			*/}
		</div>
		)
	}
}

NavBar.propTypes = {
	getActiveRoute: PropTypes.func
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/TopNavigationBar/NavBar.js